import { useEffect } from 'react';

// El <link rel="manifest"> NO va fijo en public/index.html: se inyecta solo
// mientras está montado el árbol autenticado (rama del Layout en App.js), para
// que el catálogo público (/catalogo/:slug) y las páginas sin sesión nunca
// sean instalables como app. Al cerrar sesión o salir al catálogo el
// componente se desmonta y el link se quita.
function PwaManifest() {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = `${process.env.PUBLIC_URL}/manifest.json`;
    // El navegador pide el manifest sin cookies por defecto. En los previews de
    // Vercel (protegidos por cookie) eso devuelve un 302 al login de Vercel y
    // la app deja de ser instalable. En producción no cambia nada.
    link.crossOrigin = 'use-credentials';
    document.head.appendChild(link);
    return () => link.remove();
  }, []);

  return null;
}

export default PwaManifest;
